import React from 'react';
import { GenericListPage } from '../../../components/generic';
import { useTaxAuthoritys, TaxAuthority } from './useData';
import { moduleConfig, getColumns, getToolbarIcon, getTableActions } from './config';

const List: React.FC = () => {
  return (
    <GenericListPage<TaxAuthority>
      useData={useTaxAuthoritys}
      config={{
        ...moduleConfig,
        getColumns,
        getToolbarIcon,
        getTableActions,
      }}
    />
  );
};

export default List;
